<script setup lang="ts">
  import { useFetchPartners } from "@/data/hooks/partners";
  import SettingsPage from "@/views/admin/settings/settings-page.vue";
  import PartnerPanel from "./components/partner-panel.vue";
  import VgePartnerPanel from "./components/vge-partner-panel.vue";
  import AcegPartnerPanel from "./components/aceg-partner-panel.vue";
  import { computed } from "vue";
  import { isAcegPartner, isInpressPartner, isLocalPartner, isVGEPartner } from "@/utils/partners/isVgePartner";
  import store from "@/store";
  import { Button } from "@/ui";
  import { useRouter } from "vue-router";
  import InpressPartnerPanel from "./components/inpress-partner-panel.vue";

  const { push } = useRouter();
  const { group_id } = store.getters["auth/me"];
  const { data: partners, isLoading } = useFetchPartners({ group_id, perPage: 999 });

  const vgePartners = computed(() => {
    return partners.value?.items.filter(isVGEPartner) ?? [];
  });
  const localPartners = computed(() => {
    return partners.value?.items.filter((partner) => isLocalPartner(partner)) ?? [];
  });
  const acegPartners = computed(() => {
    return partners.value?.items.filter((partner) => isAcegPartner(partner)) ?? [];
  });
  const inpressPartners = computed(() => {
    return partners.value?.items.filter((partner) => isInpressPartner(partner)) ?? [];
  });
  const partnersNotEmpty = computed(() => {
    return (partners.value?.items?.length ?? 0) > 0;
  });
</script>

<template>
  <!-- Show partners list only when on the main partners route -->
  <settings-page v-if="$route.name === 'admin-partners'" title="Partners" :is-loading="isLoading">
    <template #cta>
      <Button label="Partner" @click="push({ name: 'admin-partners-create' })" icon="pi pi-plus" />
    </template>
    <div v-if="partnersNotEmpty">
      <VgePartnerPanel v-if="vgePartners.length > 0" :partners="vgePartners" />
      <AcegPartnerPanel v-if="acegPartners.length > 0" :partners="acegPartners" />
      <InpressPartnerPanel v-if="inpressPartners.length > 0" :partners="inpressPartners" />
      <PartnerPanel v-for="partner in localPartners" :key="partner.id" :partner="partner" />
    </div>
    <div v-else>
      <div class="text-center text-gray-500">Geen partners gevonden</div>
    </div>
  </settings-page>
  <!-- Render child routes (create, edit, vge) -->
  <router-view v-else />
</template>
